import { CustomValidation } from './CustomValidation';
import { InputType } from '../Enums/InputType';
import { EnglishArabicDTO } from './EnglishArabicDTO';
import { ControlLayout } from '../Enums/ControlLayout';
import { LanguageMode } from '../Enums/LanguageMode';

export class MultiLingualTextBoxOptions {
  /** Allow to Pass Object With Body of Function which represent CustomValidation and massage for error massage 
*/
CustomValidation: CustomValidation[]=[]
/**To Set Value To MultipleLanguageText with Object From Type "EnglishArabicDTO" */
  Value: EnglishArabicDTO = new EnglishArabicDTO();
  /**  Represent value of the Label*/
   LabelValue: string;
   /**  Represent Key of the label*/
   ArabicLabelKey:string
     /**  Represent Key of the label*/
     EnglishLabelKey:string
  /**  Represent value of the ArabicLabel*/
  ArabicLabelValue: string;
  /**  Represent value of the EnglishLabel*/
  EnglishLabelValue: string;
  /**  Represent value of the LabelDescription show under textbox*/
  LabelDescription: string;
  /**  Represent value of the ArabicLabelDescription show under textbox*/
  ArabicLabelDescription: string;
  /**  Represent value of the EnglishLabelDescription show under textbox*/
  EnglishLabelDescription: string;
  /**
* Represent Name Of Form Control
*/
  Name: string;
  /**
* Represent ArabicPlaceholder Of Form Control
*/
  ArabicPlaceholder: string;
  /**
* Represent EngilshPlaceholder Of Form Control
*/
  EngilshPlaceholder: string;
  /**
*   Represent classes to Arabic textbox that allow us to select the TextBox by jquery or javascript 
*/

  ExtraClasses_AR: string;
  /**
*   Represent classes to English textbox that allow us to select the TextBox by jquery or javascript 
*/

  ExtraClasses_EN: string;
  /**  to set type of view  if textbox is Vertical or Horizontal */
  ViewType:ControlLayout=ControlLayout.Vertical
  /**Set the MinLength of characters In TextBox  */
  MinLength: number;
  //** Set the MaxLength of characters In TextBox */
  MaxLength: number;
  //** Set the MaxWordCount of characters In TextBox */
  MaxWordCount: number;
  /**  text input on change  */
  TrimTextOnChange: boolean
  /** add button to for coping to clipboard */
  EnableCopyToClipboard: boolean
  /**
* Display "*" beside the label 
* if ForceAsterisk=true and IsRequired=True his display "*" ,
* if if ForceAsterisk=false and IsRequired=false this remove "*",
*if ForceAsterisk=false and IsRequired=True this display "*" , 
*/
  ShowAsterisk: boolean
  /** Ability to set  TextBox required */
  IsRequired: boolean;
  /** Sets an attribute disable="disabled"  */
  IsDisabled: boolean;
  /** Ability to display or hide the EngilshField of TextBox */
  IsHideEngilshFields: boolean;
  /** Ability to display or hide the ArabicField of TextBox */
  IsHideArabicFields: boolean;
  /** Ability to display or hide the EngilshLabel of TextBox */
  IsHideEngilshLabel: boolean;
  /** Ability to display or hide the ArabicLable of TextBox */
  IsHideArabicLable: boolean;
  /**To Set LanguageMode To MultipleLanguageText */
  LanguageMode:LanguageMode=LanguageMode.Both_Languages_are_visible;
}
